// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("app.min." + "82131287b363f7e1c553" + ".js");